import "./style.css";

const About = () => {
    return (
        <div className="contact">
            <h1>Contact me!</h1>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29431.842035396614!2d73.15970037753542!3d22.766114045330767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e3eabe27948c7%3A0x9633908874c5eaf4!2sVanoti%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1622113113355!5m2!1sen!2sin"
                frameBorder="0"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
            ></iframe>

            <h4>Phone</h4>
            <p>+91 9773035145</p>

            <h4>Email</h4>
            <p>dhriteshpatel24@gmail.com</p>

            <h4>Address</h4>
            <p>065, Patel valu faliyu, Vanoti, 388225, Gujarat, India</p>
        </div>
    )
}

export default About
